module.exports = __webpack_public_path__ + "img/grass.11c28d4d.png";